<template>
  <v-data-table
    :headers="usr_headers"
    dense
    :items="usrList"
    :search="tableFilter"
    class="elevation-1 ma-2"
    item-key="USR_RECIPIENT"
    :items-per-page="-1"
    hide-default-footer
    :custom-filter="totalSearch"
    @click:row="onRowClick"
    :footer-props="{
        itemsPerPageText: 'На страницу'
      }"
  >
    <template v-slot:top>
      <v-toolbar color="primary" dark dense>
        <v-toolbar-title class="white--text">Справочник сотрудников</v-toolbar-title>
        <v-spacer />
        <v-text-field
          v-model="tableFilter"
          placeholder="Фамилия/имя/отчество/телефон/должность/отдел/email ..."
          append-icon="mdi-filter" clearable
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:[`item.FULL_FIO`]="{ item }">
      <contactsCard :user="item" :mode="mode" :highlight="highlight ? isSelected(item) : false" />
    </template>
    <template v-slot:no-data>
      Нет данных
    </template>
  </v-data-table>
</template>

<script>

import { USER_GET_ACCEPTORS } from '@/store/actions/user'
import { UI_SNACKBAR } from '@/store/actions/ui'
import contactsCard from '@/components/modules/org/structure/staff/userContactsCard.vue'

export default {
  props: ['value', 'mode', 'highlight'],
  components: {
    contactsCard
  },
  data () {
    return {
      usrSelected: undefined,
      tableFilter: null,
      usr_headers: [
        { text: 'Сотрудники', align: 'center', sortable: false, value: 'FULL_FIO' }
      ]
    }
  },
  computed: {
    usrList: {
      get: function () {
        return this.$store.getters.getAcceptorsList
      }
    },
    userRole: {
      get: function () {
        return this.$store.getters.getUserRole
      }
    },
    itemSelected: {
      get: function () {
        return this.usrSelected.length > 0
      }
    }
  },
  watch: {
    usrSelected (val) {
      console.log('staffList: item selected', this.usrSelected)
      this.$emit('input', val)
    }
  },
  methods: {
    onRowClick (item) {
      console.log('staffList: onRowClick called', item)
      if (item !== this.usrSelected) {
        this.usrSelected = item
      } else {
        this.usrSelected = undefined
      }
    },
    isSelected (item) {
      return item === this.usrSelected
    },
    contactSearch (contArray, val) {
      console.log('Contact search called')
      if (!(contArray instanceof Array)) { return false }
      if (contArray.length === 0) { return false }
      var rec = contArray.find(item => item.CONT_VALUE.toString().toLocaleUpperCase().indexOf(val.toString().toLocaleUpperCase()) !== -1)
      if (rec) {
        return true
      } else {
        return false
      }
    },
    totalSearch (value, search, item) {
      if (search === null) { return true }
      var ret = item.FULL_FIO.toString().toLocaleUpperCase().indexOf(search.toString().toLocaleUpperCase()) !== -1 ||
        (item.EMP_WTITLE || '').toString().toLocaleUpperCase().indexOf(search.toString().toLocaleUpperCase()) !== -1 ||
        (item.ITP_NAME || '').toString().toLocaleUpperCase().indexOf(search.toString().toLocaleUpperCase()) !== -1 ||
        this.contactSearch(item.CONTACTS, search)
      return ret
    },
    getRecords () {
      const that = this
      this.$store.dispatch(USER_GET_ACCEPTORS, {})
        .then((resp) => {
          console.log('Acceptors records got')
        })
        .catch((err) => {
          that.$store.dispatch(UI_SNACKBAR, { text: err, color: 'red darken-1' })
        })
    }
  },
  created: function () {
    console.log('Recipient usr records list component created')
    this.getRecords()
  }
}
</script>
